import {ExpandLess, ExpandMore} from '@mui/icons-material'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Badge,
    Box,
    Grid,
    Typography
} from '@mui/material'
import React, {useState} from 'react'
import {ScriptCategory as ScriptCategoryType} from '../Scripts'
import ScriptCard from './ScriptCard'

interface ScriptCategoryProps {
    category: ScriptCategoryType
}

const ScriptCategory: React.FC<ScriptCategoryProps> = ({ category }) => {
    const [expanded, setExpanded] = useState(true)

    const handleExpansionChange = () => {
        setExpanded(!expanded)
    }

    // Add safety checks for category and scripts array
    if (!category) {
        console.warn('ScriptCategory received null/undefined category')
        return null
    }

    const scripts = Array.isArray(category.scripts) ? category.scripts : []
    const dangerousCount = scripts.filter(script => script && script.dangerous).length

    return (
        <Accordion 
            expanded={expanded} 
            onChange={handleExpansionChange}
            sx={{
                '&:before': {
                    display: 'none',
                },
                boxShadow: 2,
                borderRadius: 1,
                mb: 1
            }}
        >
            <AccordionSummary 
                expandIcon={expanded ? <ExpandLess /> : <ExpandMore />}
                sx={{
                    backgroundColor: 'grey.50',
                    '&:hover': {
                        backgroundColor: 'grey.100'
                    }
                }}
            >
                <Box display="flex" alignItems="center" gap={2} width="100%">
                    <Box display="flex" alignItems="center" gap={1}>
                        {category.icon}
                        <Typography variant="h6" component="div">
                            {category.name || category.id || 'Unnamed Category'}
                        </Typography>
                    </Box>
                    
                    <Box display="flex" alignItems="center" gap={1} ml="auto">
                        <Badge 
                            badgeContent={scripts.length} 
                            color="primary"
                            sx={{ mr: 1 }}
                        >
                            <Typography variant="body2" color="text.secondary">
                                scripts
                            </Typography>
                        </Badge>
                        
                        {dangerousCount > 0 && (
                            <Badge 
                                badgeContent={dangerousCount} 
                                color="warning"
                            >
                                <Typography variant="body2" color="warning.main">
                                    dangereux
                                </Typography>
                            </Badge>
                        )}
                    </Box>
                </Box>
            </AccordionSummary>
            
            <AccordionDetails sx={{ pt: 2 }}>
                {scripts.length > 0 ? (
                    <Grid container spacing={3}>
                        {scripts.map((script) => {
                            // Add safety check for each script
                            if (!script || !script.id) {
                                console.warn('Invalid script in category:', script)
                                return null
                            }
                            
                            return (
                                <Grid item xs={12} md={6} lg={4} key={script.id}>
                                    <ScriptCard script={script} />
                                </Grid>
                            )
                        })}
                    </Grid>
                ) : (
                    <Box textAlign="center" py={4}>
                        <Typography variant="body1" color="text.secondary">
                            Aucun script disponible dans cette catégorie
                        </Typography>
                    </Box>
                )}
            </AccordionDetails>
        </Accordion>
    )
}

export default ScriptCategory